var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Color } from '@atomic/obj.constants';
// O BottomNav é fixo (5rem): o respiro inferior evita que ele cubra os últimos itens.
export var ChallengesContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 14px calc(5rem + 16px);\n"], ["\n  padding: 0 14px calc(5rem + 16px);\n"])));
// Tarefas recuadas e ligadas à fase por uma linha pontilhada.
export var TarefasContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 2px 0 14px 22px;\n  padding-left: 12px;\n  border-left: 2px dotted ", ";\n"], ["\n  margin: 2px 0 14px 22px;\n  padding-left: 12px;\n  border-left: 2px dotted ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.borderColor) || Color.GrayLight;
});
export var Status = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 16px 2px;\n  color: ", ";\n"], ["\n  margin: 16px 2px;\n  color: ", ";\n"])), Color.GrayDark);
var templateObject_1, templateObject_2, templateObject_3;
